import React, { useState, useEffect } from "react";
// eslint-disable-next-line no-unused-vars
import Spinner from "../../../components/common/spinner/Spinner";
import { Col, Container, Row, Button, Form } from "react-bootstrap";
// eslint-disable-next-line no-unused-vars
import axios from "axios";
import Notification, {
  showToast,
} from "../../../components/common/notification/Notification";
import Api from "../../components/api/Api";
// eslint-disable-next-line no-unused-vars
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// eslint-disable-next-line no-unused-vars
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import { useSelector } from "react-redux";
// eslint-disable-next-line no-unused-vars
import Profile from "./Profile";
import LocationServiceSelector from "../../components/Location/LocationServiceSelector";


const EditUser = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isError, setIsError] = useState(false);
  const userId = loggedInUser?.user?.id;
  // eslint-disable-next-line no-unused-vars
  const token = loggedInUser?.refreshToken;
  // eslint-disable-next-line no-unused-vars
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const getDetailsApi = Api({
    url: `admin/user/id/${userId}`,
  });
  const editDetailsApi = Api({
    url: `admin/editUser`, 
  }); 
  const [formData, setFormData] = useState({
    id: userId,
    user_name: "",
    first_name: "", 
    last_name: "",
    email_address: "",
    mobile_number: "",
  });
  useEffect(() => { 
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await getDetailsApi.fetchData();
        // console.log(response);
        if (response.data.statusType === "SUCCESS") {
          const userData = await response.data.user;
          console.log(userData);
          setFormData({
            ...formData,
            user_name: userData.user_name,
            first_name: userData.first_name,
            last_name: userData.last_name,
            email_address: userData.email_address,
            mobile_number: userData.mobile_number,
          });
        }
      } catch (error) {
        setIsError(true);
        console.log(error);
        showToast("Error Occurred", {
          type: "error",
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      console.log(formData);
      const responseData = await editDetailsApi.editData(formData);
      console.log(responseData);
      if (responseData.data.statusType === "SUCCESS") {
        showToast("User Edited Successfully", {
          type: "success",
        });

        setTimeout(() => {
          navigate("/user/profile");
        }, 3000);
      }
    } catch (error) {
      setIsError(true);
      showToast("Error Occurred", {
        type: "error",
      });
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  return (
    <>
      <Notification />
      <Container fluid>
        <Row className="justify-content-center">
          <Col xs={12} lg={10}>
            <Form onSubmit={handleSubmit} className="card shadow border-0 rounded-3 p-4 my-2 profile-card">
              <Row className="pb-4">
                <Col>
                  <Form.Group controlId="first_name">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="last_name">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="pb-4">
                <Col>
                  <Form.Group controlId="email_address">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      name="email_address"
                      value={formData.email_address}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="mobile_number">
                    <Form.Label>Mobile Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="mobile_number"
                      value={formData.mobile_number}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <LocationServiceSelector userId={userId}/>  

              <Button variant="primary" type="submit" className="mt-5 mb-5">
                Edit User
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EditUser;
